<template>
    <vs-row vs-w="12">
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Projects</h5>
            <vs-checkbox class="mt-3" v-model="permissionsArray" :vs-value=201>View projects</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Invoices</h5>
            <vs-checkbox class="mt-3" v-model="permissionsArray" :vs-value="101">View invoices</vs-checkbox>
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="mt-6">
            <h5 class="p-3">Tasks</h5>
            <vs-checkbox class="mt-3" v-model="permissionsArray" :vs-value="301">Add task</vs-checkbox>
            <vs-checkbox class="mt-3" v-model="permissionsArray" :vs-value="302">Confirm all tasks</vs-checkbox>
        </vs-col>
    </vs-row>
</template>
<script>
    export default {
        props: {
            permissions: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                permissionsArray: []
            }
        },
        computed:{
            permissionArray: function () {
                let list = [];
                for(let x = 0; x < this.permissionsArray.length; x++){
                    list.push(this.permissionsArray[x]);
                }

                return list;
            }
        },
        watch: {
            permissions: function () {
                this.permissionsArray = JSON.parse(JSON.stringify(this.permissions));
            },
        },
        created() {
            this.permissionsArray = JSON.parse(JSON.stringify(this.permissions));
        }
    }
</script>
